
export default {
  code: "es",
  week: {
    dow: 0, // Sunday is the first day of the week.
    doy: 6  // The week that contains Jan 1st is the first week of the year.
  },
  buttonText: {
    prev: "Ant",
    next: "Sig",
    today: "Hoy",
    month: "Mes",
    week: "Semana",
    day: "Día",
    list: "Agenda"
  },
  weekLabel: "Sm",
  allDayHtml: "Todo<br/>el día",
  eventLimitText: "más",
  noEventsMessage: "No hay eventos para mostrar"
};
